import React from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { FilterDropDown } from '@ygtechnologies/bygr-frontend-component-library';
import { OptionGroupLinkStatus } from '@/types';
import { useLingui } from '@lingui/react';

interface PublishedStatusFilterProps {
    value: OptionGroupLinkStatus[];
    onChange: (value?: OptionGroupLinkStatus[]) => void;
}

export const PublishedStatusFilter: React.FC<PublishedStatusFilterProps> = ({ value, onChange }) => {
    const { _ } = useLingui();

    const data = Object.keys(OptionGroupLinkStatus).map((x) => ({
        id: x as OptionGroupLinkStatus,
        name: _({ id: `OptionGroupLinkStatus.${x}` }),
    }));

    const selectedValues = data.filter((x) => value.includes(x.id));

    return (
        <FilterDropDown
            placeholder={t`Any status`}
            label={<Trans>Published status</Trans>}
            data={data}
            value={selectedValues}
            onChange={(v) => onChange(v.map((y) => y.id))}
            isClearable
        />
    );
};
